import React, { useEffect, useState } from 'react';
import {
  ScrollView,
  View,
  Text,
  TouchableHighlight,
  TextInput,
  TouchableOpacity,
  Dimensions,
  Modal,
} from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

import { getBrandsData, saveBrandCell, deleteBrand } from '../../../../api/Price';
import { msgStr } from '../../../../common/constants/Message';
import { TextMediumSize } from '../../../../common/constants/Fonts';
import { useAlertModal, useConfirmModal } from '../../../../common/hooks';

import { brandsStyle } from './styles/BrandsStyle';
import AddBrandModal from './AddBrandModal';
import BasicLayout from '../../../../common/components/CustomLayout/BasicLayout';
import StoreDetails from '../../../settings/storedetails/StoreDetails';

const Brands = ({ navigation, openInventory }) => {
  const screenHeight = Dimensions.get('window').height;

  const { showAlert } = useAlertModal();
  const { showConfirm } = useConfirmModal();

  const [tableData, setTableData] = useState([]);
  const [isAddModalVisible, setAddModalVisible] = useState(false);
  const openAddBrandModal = () => {
    setAddModalVisible(true);
  };
  const closeAddBrandModal = () => {
    setAddModalVisible(false);
  };
  const [updateBrandTrigger, setUpdateBrandTrigger] = useState(true);

  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [selectedBrandName, setSelectedBrandName] = useState(null);
  const [showPickupTooltip, setShowPickupTooltip] = useState(false);

  const isHelpEnabled = () => {
    if (typeof window !== 'undefined') {
      const hostname = window.location.hostname;
      return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'vehicle.bodhisys.io';
    }
    return false;
  };

  useEffect(() => {
    if (updateBrandTrigger == true) getTable();
  }, [updateBrandTrigger]);

  const changeCellData = (index, key, newVal) => {
    const updatedTableData = [...tableData];
    updatedTableData[index] = {
      ...updatedTableData[index],
      [key]: newVal,
    };
    setTableData(updatedTableData);
  };

  const togglePartnerSite = (id, currentValue) => {
    const newValue = !currentValue;
    
    // Update local state immediately for responsive UI
    const updatedTableData = tableData.map(item => 
      item.id === id ? { ...item, is_partner_site: newValue } : item
    );
    setTableData(updatedTableData);
    
    // Call the API separately
    saveBrandCell(id, 'is_partner_site', newValue, (jsonRes, status, error) => {
      switch (status) {
        case 200:
          // Success - local state already updated
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          // Revert local state on error
          const revertedTableData = tableData.map(item => 
            item.id === id ? { ...item, is_partner_site: currentValue } : item
          );
          setTableData(revertedTableData);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          // Revert local state on error
          const errorRevertedTableData = tableData.map(item => 
            item.id === id ? { ...item, is_partner_site: currentValue } : item
          );
          setTableData(errorRevertedTableData);
          break;
      }
    });
  };

  const togglePickup = (id, currentValue) => {
    const newValue = !currentValue;
    
    // Update local state immediately for responsive UI
    const updatedTableData = tableData.map(item => 
      item.id === id ? { ...item, offer_pickup: newValue } : item
    );
    setTableData(updatedTableData);
    
    // Call the API separately
    saveBrandCell(id, 'offer_pickup', newValue, (jsonRes, status, error) => {
      switch (status) {
        case 200:
          // Success - local state already updated
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          // Revert local state on error
          const revertedTableData = tableData.map(item => 
            item.id === id ? { ...item, offer_pickup: currentValue } : item
          );
          setTableData(revertedTableData);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          // Revert local state on error
          const errorRevertedTableData = tableData.map(item => 
            item.id === id ? { ...item, offer_pickup: currentValue } : item
          );
          setTableData(errorRevertedTableData);
          break;
      }
    });
  };

  const toggleWalkup = (id, currentValue) => {
    const newValue = !currentValue;

    // Update local state immediately for responsive UI
    const updatedTableData = tableData.map(item =>
      item.id === id ? { ...item, is_walkup: newValue } : item
    );
    setTableData(updatedTableData);

    // Call the API separately
    saveBrandCell(id, 'is_walkup', newValue, (jsonRes, status, error) => {
      switch (status) {
        case 200:
          // Success - local state already updated
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          // Revert local state on error
          const revertedTableData = tableData.map(item =>
            item.id === id ? { ...item, is_walkup: currentValue } : item
          );
          setTableData(revertedTableData);
          break;
      }
    });
  };

  const saveCellData = (id, column, value) => {
    value = value ? value : '';

    saveBrandCell(id, column, value, (jsonRes, status, error) => {
      switch (status) {
        case 200:
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          setUpdateBrandTrigger(true);
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  const openStoreDetail = (id, tableName) => {
    setSelectedBrandId(id);
    setSelectedBrandName(tableName);
  };

  const removeBrand = (id) => {
    showConfirm(msgStr('deleteConfirmStr'), () => {
      deleteBrand(id, (jsonRes, status, error) => {
        switch (status) {
          case 200:
            setUpdateBrandTrigger(true);
            showAlert('success', jsonRes.message);
            break;
          default:
            if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
            else showAlert('error', msgStr('unknownError'));
            break;
        }
      });
    });
  };

  const getTable = () => {
    getBrandsData((jsonRes, status, error) => {
      switch (status) {
        case 200:
          setUpdateBrandTrigger(false);
          setTableData(jsonRes);
          break;
        case 500:
          showAlert('error', msgStr('serverError'));
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          break;
      }
    });
  };

  if (selectedBrandId) {
    return (
      <StoreDetails
        navigation={navigation}
        brandId={selectedBrandId}
        brandName={selectedBrandName}
        openStoreDetail={openStoreDetail}
      ></StoreDetails>
    );
  }

  const renderTableData = () => {
    const rows = [];
    if (tableData.length > 0) {
      tableData.map((item, index) => {
        rows.push(
          <View key={index} style={styles.tableRow}>
            <View style={styles.cell}>
              <TextInput
                style={styles.cellInput}
                value={item.brand}
                onChangeText={(value) => {
                  changeCellData(index, 'brand', value);
                }}
                onBlur={(e) => {
                  saveCellData(item.id, 'brand', item.brand);
                }}
              />
            </View>

            <View style={[styles.cell, { width: 250 }]}>
              {item.storedetail?.store_url ? (
                <TouchableOpacity
                  onPress={() => {
                    if (typeof window !== 'undefined') {
                      const hostname = window.location.hostname;
                      let targetUrl;
                      
                      if (hostname === 'vehicle.bodhisys.io' || hostname === 'staging-vehicle.bodhisys.io' || hostname === 'localhost' || hostname === '127.0.0.1') {
                        targetUrl = `https://${item.storedetail.store_url}/rental`;
                      } else {
                        targetUrl = `https://${item.storedetail.store_url}`;
                      }
                      
                      window.open(targetUrl, '_blank');
                    }
                  }}
                >
                  <Text style={styles.linkText}>{item.storedetail.store_url}</Text>
                </TouchableOpacity>
              ) : (
                <Text style={styles.cellText}>-</Text>
              )}
            </View>

            <View style={[styles.IconCell, { width: 100 }]}>
              <TouchableOpacity
                onPress={() => {
                  openStoreDetail(item.id, item.brand);
                }}
              >
                <FontAwesome5 size={15} name="store" color="black" />
              </TouchableOpacity>
            </View>

            <View style={[styles.checkboxCell]}>
              <TouchableOpacity
                onPress={() => {
                  togglePartnerSite(item.id, item.is_partner_site);
                }}
              >
                <View style={[
                  styles.checkbox,
                  item.is_partner_site && styles.checkboxChecked
                ]}>
                  {item.is_partner_site && (
                    <Text style={styles.checkmark}>✓</Text>
                  )}
                </View>
              </TouchableOpacity>
            </View>

            <View style={[styles.checkboxCell]}>
              <TouchableOpacity
                onPress={() => {
                  togglePickup(item.id, item.offer_pickup);
                }}
              >
                <View style={[
                  styles.checkbox,
                  item.offer_pickup && styles.checkboxChecked
                ]}>
                  {item.offer_pickup && (
                    <Text style={styles.checkmark}>✓</Text>
                  )}
                </View>
              </TouchableOpacity>
            </View>

            <View style={[styles.checkboxCell]}>
              <TouchableOpacity
                onPress={() => {
                  toggleWalkup(item.id, item.is_walkup);
                }}
              >
                <View style={[
                  styles.checkbox,
                  item.is_walkup && styles.checkboxChecked
                ]}>
                  {item.is_walkup && (
                    <Text style={styles.checkmark}>✓</Text>
                  )}
                </View>
              </TouchableOpacity>
            </View>

            <View style={[styles.cell, { width: 120 }]}>
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate('Settings', { initialItem: 'CMS Settings', initialBrandId: String(item.id) });
                }}
                style={styles.cmsButton}
              >
                <Text style={styles.cmsButtonText}>CMS Settings</Text>
              </TouchableOpacity>
            </View>

            <View style={[styles.IconCell]}>
              <TouchableOpacity
                onPress={() => {
                  removeBrand(item.id);
                }}
              >
                <FontAwesome5 size={15} name="times" color="black" />
              </TouchableOpacity>
            </View>
          </View>
        );
      });
    } else {
      <></>;
    }
    return <>{rows}</>;
  };

  return (
    <BasicLayout
      navigation={navigation}
      goBack={() => {
        openInventory(null);
      }}
      screenName={'Brands'}
    >
      <ScrollView horizontal={true}>
        <View style={styles.container}>
          <View style={styles.toolbar}>
            <TouchableHighlight style={styles.button} onPress={openAddBrandModal}>
              <Text style={styles.buttonText}>Add</Text>
            </TouchableHighlight>
            {isHelpEnabled() && (
              <View style={styles.helpIconContainer}>
                <TouchableOpacity
                  onPress={() => setShowPickupTooltip(true)}
                  style={styles.helpIconButton}
                >
                  <FontAwesome5 name="question-circle" size={20} color="#2e96e1" />
                  <Text style={styles.helpIconText}>Pickup Flow Help</Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
          
          <Modal
            visible={showPickupTooltip}
            transparent={true}
            animationType="fade"
            onRequestClose={() => setShowPickupTooltip(false)}
          >
            <TouchableOpacity 
              style={styles.modalBackdrop}
              activeOpacity={1}
              onPress={() => setShowPickupTooltip(false)}
            >
              <View style={styles.tooltipModal}>
                <TouchableOpacity
                  style={styles.tooltipClose}
                  onPress={() => setShowPickupTooltip(false)}
                >
                  <FontAwesome5 name="times" size={14} color="#666" />
                </TouchableOpacity>
                <Text style={styles.tooltipTitle}>Pickup Flow Scenarios</Text>
                <Text style={styles.tooltipText}>
                  <Text style={styles.tooltipBold}>Partner Site ✓ + Offer Pickup ✗:</Text>
                  {' '}Users skip area/preferences and land directly on product selection with delivery auto-set.{"\n\n"}
                  <Text style={styles.tooltipBold}>Partner Site ✗ + Offer Pickup ✓:</Text>
                  {' '}Normal e-commerce flow with all steps.{"\n\n"}
                  <Text style={styles.tooltipBold}>Partner Site ✓ + Offer Pickup ✓:</Text>
                  {' '}Users skip area, select pickup location, then products.
                </Text>
              </View>
            </TouchableOpacity>
          </Modal>
          
          <View style={styles.tableContainer}>
            <View style={styles.tableHeader}>
              <Text style={styles.columnHeader}>{'Brand'}</Text>
              <Text style={[styles.columnHeader, { width: 250 }]}>{'Store URL'}</Text>
              <Text style={[styles.columnHeader, styles.IconCell, { width: 100 }]}>
                {'Store details'}
              </Text>
              <Text style={[styles.columnHeader, styles.checkboxHeader]}>{'Is Partner Site'}</Text>
              <Text style={[styles.columnHeader, styles.checkboxHeader]}>{'Do they offer pickup'}</Text>
              <Text style={[styles.columnHeader, styles.checkboxHeader]}>{'Is Walk-up Brand'}</Text>
              <Text style={[styles.columnHeader, { width: 120, textAlign: 'center' }]}>{"CMS"}</Text>
              <Text style={[styles.columnHeader, styles.IconCell]}>{"DEL"}</Text>
            </View>
            <ScrollView style={{ flex: 1, maxHeight: screenHeight - 220 }}>
              {renderTableData()}
            </ScrollView>
          </View>

          <AddBrandModal
            isModalVisible={isAddModalVisible}
            setUpdateBrandTrigger={setUpdateBrandTrigger}
            closeModal={closeAddBrandModal}
          />
        </View>
      </ScrollView>
    </BasicLayout>
  );
};

const styles = brandsStyle;

export default Brands;
